import { c as _c } from "react/compiler-runtime";
import type { Iso3166TwoDigitCountryCode } from '@onefootprint/request-types';
import type { ComponentProps } from 'react';
import NavigationHeader from '@/idv2/features/collect-document/components/navigation-header';
import DesktopPhotoPrompt from '../../../components/desktop-photo-prompt';
import type { IdDocImageErrorType, IdDocImageUploadError } from '../../../types';
type DesktopCaptureViewProps = {
  docName: string;
  sideName: string;
  country: Iso3166TwoDigitCountryCode;
  errors: IdDocImageErrorType[] | undefined;
  hasBadConnectivity: boolean | undefined;
  allowPdf: boolean;
  isRetry: boolean;
  onBack: (() => void) | undefined;
  onComplete: ComponentProps<typeof DesktopPhotoPrompt>['onUploadSuccess'];
  onUploadError: (errs: IdDocImageUploadError[]) => void;
};
const DesktopCaptureView = t0 => {
  const $ = _c(15);
  const {
    docName,
    sideName,
    country,
    errors,
    hasBadConnectivity,
    allowPdf,
    isRetry,
    onBack,
    onComplete,
    onUploadError
  } = t0;
  let t1;
  if ($[0] !== onBack) {
    t1 = <NavigationHeader leftButton={{
      variant: "back",
      onBack
    }} />;
    $[0] = onBack;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== allowPdf || $[3] !== country || $[4] !== docName || $[5] !== errors || $[6] !== hasBadConnectivity || $[7] !== isRetry || $[8] !== onComplete || $[9] !== onUploadError || $[10] !== sideName) {
    t2 = <DesktopPhotoPrompt country={country} docName={docName} errors={errors} hasBadConnectivity={hasBadConnectivity} isRetry={isRetry} onUploadError={onUploadError} onUploadSuccess={onComplete} allowPdf={allowPdf} sideName={sideName} />;
    $[2] = allowPdf;
    $[3] = country;
    $[4] = docName;
    $[5] = errors;
    $[6] = hasBadConnectivity;
    $[7] = isRetry;
    $[8] = onComplete;
    $[9] = onUploadError;
    $[10] = sideName;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== t1 || $[13] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default DesktopCaptureView;